import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type TvStory from "./TvStory";

@Model()
class TvStoryFragment extends ApplicationRecord {
  static jsonapiType = "tv_story_fragments";

  @Attr({ persist: false }) channelId: number;

  @Attr({ persist: false }) endTime: number;

  @Attr() speaker: string;

  @Attr({ persist: false }) startTime: number;

  @Attr() text: string;

  @BelongsTo() tvStory: TvStory;

  @Attr({ persist: false }) tvStoryId: number;
}

export default TvStoryFragment;
